export const cachingPanelData = {
  lading: "port_of_lading",
  unlading: "port_of_unlading",
};
